import { useQuery } from "@tanstack/react-query";
import { Item } from "../../types/item";
import { httpClient } from "@coworker/http-client";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import { isEmpty } from "../../helpers/string.helper";
import { isValidItemNumber } from "@coworker/utils/products.helper";

export async function fetchItemInfo(itemNo: string): Promise<Item | null> {
  if (!isValidItemNumber(itemNo)) {
    return null;
  }

  const result = await httpClient.tasks.get<Item>(
    `/items/item-info?itemNo=${itemNo}`
  );

  return result && !isEmpty(result)
    ? ({
        ...result,
        noFormatted: formatProductIdWithDots(result?.no),
      } as Item)
    : null;
}

// Fetches Items info from Items table if found or SR
// Doesn't contain price and currency info
export const useItemInfo = (itemNo: string) => {
  return useQuery({
    queryKey: ["item", "info", itemNo],
    queryFn: async () => await fetchItemInfo(itemNo),
    enabled: !!itemNo,
    refetchOnWindowFocus: false,
    staleTime: 86400000, // cache 24 hours
  });
};
